import { useEffect } from 'react';
import { RouteComponentProps } from '@reach/router';
import {
  CheckCircleOutlined,
  LogoutOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import { useProcessDataContext } from '@datapeace/ams-web-components';
import { BRAND_NAME } from '@datapeace/ams-web-utils';
import styles from './welcome.module.scss';
import { Button, Flex, Image, Typography, FloatButton } from 'antd-5';
import { Content, Layout } from '@datapeace/1up-frontend-web-ui-antd5';

export function Welcome(props: RouteComponentProps) {
  const {
    config,
    settings,
    handleResetProcess,
    handleNavigateToSettings,
    handleStartProcess,
    handleManualStartProcess,
  } = useProcessDataContext();

  if (!config) throw new Error('Config not found in Welcome');

  const {
    portalLogoUrl,
    portalBackgroundImageUrl,
    punchInLabel,
    punchOutLabel,
    punchType,
    punchBothMode,
  } = config;

  const { processType } = settings;

  useEffect(() => {
    handleResetProcess();
  }, [handleResetProcess]);

  const effectivePunchType = punchType ?? processType?.toLowerCase();

  const getPunchLabel = () => {
    if (effectivePunchType === 'in') return punchInLabel || 'Punch In';
    if (effectivePunchType === 'out') return punchOutLabel || 'Punch Out';
    return punchInLabel && punchOutLabel
      ? `${punchInLabel}/${punchOutLabel}`
      : 'Punch In/Out';
  };

  return (
    <Layout
      className={styles.Welcome}
      style={{
        backgroundImage: portalBackgroundImageUrl
          ? `url("${portalBackgroundImageUrl}")`
          : undefined,
      }}
    >
      <FloatButton
        type="default"
        className={styles.FloatButton}
        icon={<SettingOutlined />}
        shape="circle"
        tooltip="Settings"
        onClick={handleNavigateToSettings}
      />
      <Typography.Text className={styles.FloatButton__Text}>
        Powered by&nbsp;{BRAND_NAME}
      </Typography.Text>

      <Content>
        <Flex align="center" justify="center" vertical gap="middle">
          <Image
            src={portalLogoUrl || '/images/ams_logo.png'}
            className={styles.Logo}
            alt="1UPAMS"
            preview={false}
            loading="eager"
            fallback="/images/ams_logo.png"
          />

          {effectivePunchType === 'both' && punchBothMode === 'manual' ? (
            <>
              <Button
                onClick={() => handleManualStartProcess('in')}
                type="primary"
                iconPosition="end"
                size="large"
                className={styles.XLargeButton}
                icon={<CheckCircleOutlined />}
              >
                {punchInLabel || 'Punch In'}
              </Button>
              <Button
                onClick={() => handleManualStartProcess('out')}
                type="primary"
                iconPosition="end"
                size="large"
                className={styles.XLargeButton}
                icon={<LogoutOutlined />}
              >
                {punchOutLabel || 'Punch Out'}
              </Button>
            </>
          ) : (
            <Button
              onClick={handleStartProcess}
              type="primary"
              iconPosition="end"
              size="large"
              className={styles.XLargeButton}
              icon={
                effectivePunchType === 'out' ? (
                  <LogoutOutlined />
                ) : (
                  <CheckCircleOutlined />
                )
              }
            >
              {getPunchLabel()}
            </Button>
          )}
        </Flex>
      </Content>
    </Layout>
  );
}
